import { getAxiosClient } from "../../axios-client";
import { AddStorageAreaRequestBody, AddStorageAreaResponse } from "./types";

const axiosClient = getAxiosClient();
export const addStorageArea = async (body: AddStorageAreaRequestBody) => {
  return await axiosClient.ax.post<AddStorageAreaResponse>(
    "StorageArea/Add",
    body
  );
};
